var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import { useTable, useExpanded } from 'react-table';
import { ChevronRight, ChevronDown } from 'styled-cssgg';
import { borderRadius } from '../theme/border-radius';
const Styles = styled.div `
  padding: 8px;
  background-color: ${() => 'var(--table-row-color-0)'};
  border-radius: ${borderRadius.md};

  table {
    border-spacing: 0;
    overflow: hidden;
    width: 100%;

    tr {
      max-height: 0px;
      :last-child {
        td {
          border-bottom: 0;
        }
      }
    }

    th,
    td {
      padding: 4px 16px;
    }

    &[data-expandable='true'] {
      th:first-child {
        padding: 0px;
      }
      td:first-child {
        padding: 0px;
      }
    }

    th,
    td {
      margin: 0;

      :last-child {
        border-right: 0;
      }
    }
  }

  [data-role='icon'] {
    color: ${() => 'var(--text-color-2)'};
    --ggs: 0.75;
    display: flex;
    align-self: center;
  }
`;
const StyledThead = styled.thead `
  border-collapse: collapse;
  line-height: 24px;
  tr:first-child {
    display: none;
  }
  th {
    border-bottom: ${() => '1px solid var(--table-row-color-0)'};
    text-align: left;
    font-size: 12px;
    color: ${() => 'var(--text-color-2)'};
  }
`;
const StyledIconWrapper = styled.span `
  display: inline-block;
  height: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  display: flex;
  align-items: center;
  padding-left: ${(props) => props.paddingLeft};
`;
const StyledTbody = styled.tbody `
  tr:nth-child(2n) {
    background-color: ${() => 'var(--table-row-color-1)'};
    td:first-child {
      border-radius: ${borderRadius.md} 0px 0px ${borderRadius.md};
    }
    td:last-child {
      border-radius: 0px ${borderRadius.md} ${borderRadius.md} 0px;
    }
  }
  tr:nth-child(2n + 1) {
    background-color: ${() => 'var(--table-row-color-0)'};
  }
  td {
    padding: 4px 16px;
    color: ${() => 'var(--button-text-color)'};
  }
  td:first-child {
    position: relative;
  }
`;
function InnerTable({ columns: userColumns, data, expandable }) {
    const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable({
        columns: userColumns,
        data,
    }, useExpanded);
    return (React.createElement(React.Fragment, null,
        React.createElement("table", Object.assign({ "data-role": "table-table" }, getTableProps(), { "data-expandable": expandable }),
            React.createElement(StyledThead, { "data-role": "table-header" }, headerGroups.map((headerGroup) => (React.createElement("tr", Object.assign({}, headerGroup.getHeaderGroupProps()), headerGroup.headers.map((column) => (React.createElement("th", Object.assign({}, column.getHeaderProps()), column.render('Header')))))))),
            React.createElement(StyledTbody, Object.assign({ "data-role": "table-body" }, getTableBodyProps()), rows.map((row) => {
                prepareRow(row);
                return (React.createElement("tr", Object.assign({}, row.getRowProps()), row.cells.map((cell) => {
                    return React.createElement("td", Object.assign({}, cell.getCellProps()), cell.render('Cell'));
                })));
            })))));
}
export function Table(_a) {
    var { columns } = _a, props = __rest(_a, ["columns"]);
    const computedColumns = React.useMemo(() => [
        ...(props.expandable
            ? [
                {
                    // Build our expander column
                    id: 'expander',
                    Header: ({ getToggleAllRowsExpandedProps, isAllRowsExpanded }) => (React.createElement("span", Object.assign({}, getToggleAllRowsExpandedProps(), { "data-role": "icon" }), isAllRowsExpanded ? React.createElement(ChevronDown, null) : React.createElement(ChevronRight, null))),
                    Cell: ({ row }) => 
                    // Use the row.canExpand and row.getToggleRowExpandedProps prop getter
                    // to build the toggle for expanding a row
                    row.canExpand ? (React.createElement(StyledIconWrapper, Object.assign({}, row.getToggleRowExpandedProps(), { paddingLeft: `${row.depth * 16}px`, "data-role": "icon" }), row.isExpanded ? React.createElement(ChevronDown, null) : React.createElement(ChevronRight, null))) : null,
                },
            ]
            : []),
        {
            Header: 'Name',
            columns: (columns === null || columns === void 0 ? void 0 : columns.map((item) => ({
                Header: item.title,
                accessor: item.dataIndex,
            }))) || [
                {
                    Header: 'First Name',
                    accessor: 'firstName',
                },
                {
                    Header: 'Last Name',
                    accessor: 'lastName',
                },
            ],
        },
    ], [columns]);
    return (React.createElement(Styles, { "data-role": "table" },
        React.createElement(InnerTable, { expandable: props.expandable, columns: computedColumns, data: props.dataSource })));
}
